import React, { useContext, useState } from "react";
import { themeContext } from "../../../Context";
import { erpFaqs } from "../../../seo/seoConfig";
import "./Faq.css";

const Faq = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="erp-faq" id="erp-faq">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>
          أسئلة شائعة عن برنامج المحاسبة ونظام ERP
        </h2>
        <p>إجابات مختصرة عن الفوترة الإلكترونية وZATCA والوحدات وبدء العمل.</p>
      </div>
      <div className="faq-list">
        {erpFaqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div className={`faq-item${isOpen ? " open" : ""}`} key={item.q}>
              <button
                type="button"
                className="faq-question"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                style={{ color: darkMode ? "white" : undefined }}
              >
                <span>{item.q}</span>
                <span className="faq-icon" aria-hidden="true">
                  {isOpen ? "−" : "+"}
                </span>
              </button>
              {isOpen ? <p className="faq-answer">{item.a}</p> : null}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Faq;
